import axios from '@axios'

const route = 'manager_accommodation'
export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    getAll(context, {
      itemsPerPage, page, search, filter,
    }) {
      const params = new URLSearchParams({
        page,
        items_per_page: itemsPerPage,
      })

      // Só adiciona o search se tiver valor
      if (search && search.trim() !== '') {
        params.append('search', search.trim())
      }

      return axios.post(`${route}/checkouts?${params.toString()}`, filter)
    },

    // store(context, card) {
    //   return axios.post(route, card)
    // },
    // update(context, card) {
    //   return axios.put(`${route}/${card.id}`, card)
    // },
    // delete(context, card) {
    //   return axios.delete(`${route}/${card.id}`)
    // },
    printCheckoutPdf(context, checkout) {
      return axios.get(`${route}/export_pdf/${checkout.id}`, { responseType: 'blob' })
    },
    printGroupAccountRoomStatement(context, checkout) {
      return axios.get(`${route}/group_account_room_statement/${checkout.id}`, { responseType: 'blob' })
    },
    sendToGestao(context) {
      return axios.post(`${route}/send_to_gestao`)
    },
    sendSingleCheckout(context, checkoutId) {
      return axios.post(`${route}/send_single_checkout/${checkoutId}`)
    },
    revertCheckout(context, checkout) {
      return axios.post(`${route}/revert_checkout/${checkout}`)
    },
    exportPdfReport(context, payload) {
      return axios.post(`${route}/export_report_pdf`, payload, { responseType: 'blob' })
    },
    exportPdfRps(context, checkout) {
      return axios.get(`${route}/export_pdf_rps/${checkout.id}`, { responseType: 'blob' })
    },

    // Notas fiscais (proxy backend)
    getNotesByReserve(context, { reserveId }) {
      return axios.get(`${route}/notes/by_reserve/${reserveId}`)
    },
    generateNotesByReserve(context, { reserveId, serverId }) {
      const payload = {}
      if (serverId) payload.server_id = serverId

      return axios.post(`${route}/notes/by_reserve/${reserveId}`, payload)
    },

  },
}
